import React from "react";
import { useParams} from 'react-router-dom';
import Header from "@shared/Header";
import history from '@history'
import { DASHBOARD_ROUTE, MYWALLET_ROUTE } from "@constants/routes";

export default function Return() {
  const {connectedAccountId} = useParams();

  React.useEffect(() => {
    setTimeout(() => {
      history.push(`${DASHBOARD_ROUTE}${MYWALLET_ROUTE}`) // Replace '/target-route' with your desired route
    }, 2000);
    }, [])

  return (
    <>
    <Header/>
    <div className="container"
       style={{
       display:"flex",
       flexDirection:"column", 
       justifyContent:'center',
       alignItems:"center", 
       height:"88vh",
       }}>
      <div className="banner">
        <h2>Thank you! You have successfully onboarded. Redirecting to the Wallet...</h2>
      </div>
      {/* <div className="content">
        <h2>Details submitted</h2>
        <p>That's everything we need for now</p>
      </div> */}
      {/* <div className="info-callout">
        <p>
        This is a sample app for Stripe-hosted Connect onboarding. <a href="https://docs.stripe.com/connect/onboarding/quickstart?connect-onboarding-surface=hosted" target="_blank" rel="noopener noreferrer">View docs</a>
        </p>
      </div> */}
    </div>
    </>
  );
}